import { Injectable } from '@angular/core';
import {
    HttpContextToken,
    HttpEvent,
    HttpHandler,
    HttpInterceptor,
    HttpRequest,
    HttpResponse
} from '@angular/common/http';
import { Observable, of, tap } from 'rxjs';
import { CacheService } from "./cache.service";

export const CACHE_TTL_LOW: number = 5 * 60 * 1000;
export const CACHE_TTL_MID: number = 60 * 60 * 1000;
export const CACHE_TTL_HIGH: number = 12 * 60 * 60 * 1000;

export const CACHE_TTL = new HttpContextToken<number>(() => CACHE_TTL_LOW);

@Injectable()
export class CacheInterceptor implements HttpInterceptor {

    constructor(private cacheService: CacheService) {
    }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        if (req.context.has(CACHE_TTL)) {
            let ttl: number = req.context.get(CACHE_TTL);
            const cacheKey = this.createCacheKey(req.urlWithParams, req.method, req.body);
            const cachedResponse = this.cacheService.getCache(cacheKey);
            if (cachedResponse) {
                return of(cachedResponse);// Return cached response if available
            }
            return next.handle(req).pipe(
                tap((event) => {
                    if (event instanceof HttpResponse) {
                        this.cacheService.setCache(cacheKey, event, ttl);
                    }
                })
            );
        } else {
            return next.handle(req);
        }
    }

    private createCacheKey(url: string, method: string, body: any): string {
        const bodyHash = this.simpleHash(JSON.stringify(body)).toString();
        return `${url}_${method}_${bodyHash}`;
    }

    /** Generates a Hash to be appended with key */
    private simpleHash(str: string): string {
        let hash = 0;
        if (str.length === 0) return hash.toString();
        for (let i = 0; i < str.length; i++) {
            const char = str.charCodeAt(i);
            hash = (hash << 5) - hash + char;
            hash = hash & hash; // Convert to 32bit integer
        }
        return hash.toString();
    }
}
